import moment from "moment";
import React, { useEffect, useState } from "react";
import { Fund } from "./type";

const columns = [
  { type: "string", id: "Fund" },
  { type: "string", id: "Valuation" },
  { type: "date", id: "Start" },
  { type: "date", id: "End" },
];

export default function FundGrowthChart({ funds }: { funds: Array<Fund> }) {
  const [chart, setChart] = useState(null);
  const rows = funds.map(f => [f.fundName, `Valuation: ₹${f.reportDayValuation}`, moment(f.transactions[0].date, 'DD-MMM-YYYY').toDate(),
  moment(f.transactions[f.transactions.length - 1].date, 'DD-MMM-YYYY').toDate()]);
  const data = [columns, ...rows];
  useEffect(() => {
    async function loadGoogleChart() {
      if (typeof window !== 'undefined') {
        const Chart = await import('react-google-charts');
        setChart(<Chart.Chart chartType="Timeline" data={data} width="100%" height={'600px'}/>);
      }
    }
    setTimeout(() => loadGoogleChart(), 1000);
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>{chart}</>;
}
